import './App.css';
import AppRouter from './Router';
import { HeroUIProvider  } from "@heroui/react";
// import { BalanceProvider } from './contexts/BalanceContext';

function App() {
  return (
    // <BalanceProvider>
    <HeroUIProvider>
      <AppRouter />
    </HeroUIProvider>
    // </BalanceProvider>
  );
}

export default App;
